module.exports = __webpack_public_path__ + "img/collection-memoireRingsWhite@2x.ccaff42.webp";